import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import ReplayIcon from '@mui/icons-material/Replay';

import classes from './Feedback.module.css';

const Feedback = props => {
  const { t } = useTranslation(['lesson']);
  return (
    <>
      <div className={classes.feedbackContainer}>
        <aside className={classes.leftSection}>
          {props.calificationData.autoEvaluate ? (
            <>
              <p className={classes.text}>{t('your_review')}</p>
              <p className={classes.text}>
                {t('qualification')}:{' '}
                <span className={classes.score}>
                  {props.evaluate.score}
                </span>
              </p>
              {props.evaluate.score < 70 && (
                <p className={classes.feedbackText}>
                  {t('not_approving')}
                </p>
              )}
              {/* <p>{date}</p> */}
            </>
          ) : (
            <p className={classes.text}>{t('your_review')}</p>
          )}
        </aside>
        <aside className={classes.rightSection}>
          {props.calificationData.autoEvaluate && (
            <>
              <p className={classes.text}>Retroalimentación</p>
              <p className={classes.feedbackText}>
                {props.evaluate.score <=
                props.feedbackData.response.firstRange ? (
                  <span>
                    {props.feedbackData.response.firstRangeFeed}
                  </span>
                ) : props.evaluate.score <=
                  props.feedbackData.response.secondRange ? (
                  <span>
                    {props.feedbackData.response.secondRangeFeed}
                  </span>
                ) : props.evaluate.score <=
                  props.feedbackData.response.thirdRange ? (
                  <span>
                    {props.feedbackData.response.thirdRangeFeed}
                  </span>
                ) : (
                  ''
                )}
              </p>
            </>
          )}
        </aside>
      </div>
      <aside className={classes.btnsContainer}>
        <Button
          onClick={props.returnVideo}
          className={classes.nextBtn}
        >
          {t('try_again')} <ReplayIcon />
        </Button>
      </aside>
    </>
  );
};

Feedback.propTypes = {
  // eslint-disable-next-line react/require-default-props
  feedbackData: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  calificationData: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  evaluate: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  changeView: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  returnVideo: PropTypes.func
};

export default Feedback;
